export enum ResultType {
  ALL = "all",
  ARTICLE = "articles",
  COUPON = "coupons",
  ISSUE = "issues",
  VIDEO = "videos",
}

export enum ArticleType {
  ARTICLE = "article",
}

export enum DisplayCountInAllSection {
  ARTICLE = 4,
  COUPON = 10,
  ISSUE = 4,
  VIDEO = 10,
}
